import React from "react";
import loadingimg from "./Assets/images/loading image 1.png";
import CircularProgress from "@mui/material/CircularProgress";

function Loader({ loading }) {
  if (!loading) return null;

  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100vw",
        height: "100vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        backgroundColor: "#fdfdfd",
        zIndex: 9999,
      }}
    >
      <div style={{ position: "relative", width: "10rem", height: "10rem" }}>
        <CircularProgress
          style={{ width: "100%", height: "100%", color: "#DA6E0B" }}
          thickness={1}
        />
        <div
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <img
            src={loadingimg}
            style={{ width: "80%", height: "80%" }}
            alt="Loading"
          />
        </div>
      </div>
    </div>
  );
}

export default Loader;
